import { defineComponent } from 'vue'
import { useNamespace } from '@lit-element/hooks'
import { useToolbar } from '../composables/use-editor-md-toolbar'
import ToolbarItem from './toolbar-item'
// import './toolbar.scss'

const ns = useNamespace('md-toolbar')

export default defineComponent({
  name: 'LtMdToolbar',
  setup() {
    const { toolbars, toolbarConfig, customToolbars } = useToolbar()
    const tempToolbars = { ...toolbars, ...customToolbars }

    return () => (
      <div class={ns.b('container')}>
        {toolbarConfig?.map((item: any, index: any) =>
          Array.isArray(item) ? (
            <>
              {item.map((key, idx) => (
                <ToolbarItem
                  config={tempToolbars[key]}
                  key={`${index}-${idx}`}
                />
              ))}
              <span class={ns.b('span')}></span>
            </>
          ) : (
            <ToolbarItem config={tempToolbars[item]} key={index} />
          )
        )}
      </div>
    )
  },
})
